export const SET_SUBMISSION_TYPE = 'SET_SUBMISSION_TYPE'
